/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {VexCSSDialogContainer as ɵa} from './lib/vex-css-dialog-container';